import axios from 'axios';
import {
  requestInterceptor,
  errorResponseInterceptor,
} from '@/helpers/api/refreshTokenInterceptors';
import { getAuthHeader } from './headers';

const client = axios.create({
  baseURL: import.meta.env.VITE_SYNC_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
});

client.interceptors.request.use((config) => requestInterceptor(config));

client.interceptors.response.use(
  (response) => response,
  (error) => errorResponseInterceptor(error)
);

/**
 * Sync Assets API
 */

export const uploadImagesToSyncAssetsAPI = async ({ siteId, images, storageType }) => {
  return await client.post(
    `assets/${siteId}/upload`,
    images.map(({ name, hash }) => ({ name, hash, storageType })),
    {
      headers: getAuthHeader(),
    }
  );
};

export const checkAssetsAsUploaded = ({ siteId, images }) => {
  return client.put(`assets/${siteId}/uploaded`, images, {
    headers: getAuthHeader(),
  });
};

export const uploadImagesToSyncS3Bucket = async ({ url, fields, image }) => {
  const formData = new FormData();

  Object.entries(fields).forEach(([key, value]) => formData.append(key, value));
  formData.append('file', image.blob, image.name);

  return await fetch(url, {
    method: 'POST',
    body: formData,
    keepalive: false,
  });
};

export const createSyncData = async (site_id, payload) => {
  const { data } = await client.post(`sync/${site_id}`, payload, {
    headers: getAuthHeader(),
  });
  return data.payload;
};
